import { INexusRMAOrderItem } from "~/components/RMAForm/NexusRMAProductSelector";
import { IOrder as INexusOrder } from "~/graphql/queries/order/orderByName";

export const nexusRmaTemplate = (
  reason: string,
  comment: string,
  order: INexusOrder,
  rmaOrderItems: INexusRMAOrderItem[]
) =>
  `
RMA Request
===========

Customer requests to return the following products from their order:

Reason: ${reason}

Products:
${rmaOrderItems
  .map(rmaOrderItem => orderItemTemplate(order, rmaOrderItem))
  .join("\n")}

Comment:

${comment}
`.trim();

const orderItemTemplate = (
  order: INexusOrder,
  rmaOrderItem: INexusRMAOrderItem
) => {
  const orderItem = orderItemById(order, rmaOrderItem.orderItemId);

  if (!orderItem) {
    return `${rmaOrderItem.quantity}x Order item with id "${
      rmaOrderItem.orderItemId
    }"`;
  }

  const {
    node: {
      shopProduct: { shopifyProduct }
    }
  } = orderItem;
  return `${rmaOrderItem.quantity}x ${shopifyProduct.title}${
    rmaOrderItem.barcode ? ` (${rmaOrderItem.barcode})` : ""
  }`;
};

const orderItemById = (order: INexusOrder, orderItemId: string) =>
  order.orderLineItems.edges.find(
    ({ node: orderLineItem }) => orderLineItem.id === orderItemId
  );



// WEBPACK FOOTER //
// ./src/config/nexus_rma_template.ts